/* ============
 * GeneralStats Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from './Transformer'

export default class GeneralStatsTransformer extends Transformer {
  static fetch (item) {
    return {
      lifetimeAvg: item && item['lifetime_avg'] ? +item['lifetime_avg'] : 0,
      lifetimeClaims: item && item['lifetime_claims'] ? +item['lifetime_claims'] : 0,
      lifetimeSales: item && item['lifetime_sales'] ? +item['lifetime_sales'] : 0,
      lifetimeTrx: item && item['lifetime_trx'] ? +item['lifetime_trx'] : 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/GeneralStatsTransformer.js